/* eslint-disable-next-line import/no-unresolved */
import { useMemo } from 'react';
import { SWAP_DISPLAY_REALIZED } from '../constants/portfolio';
import { getPortfolioPlTrendSwapDisplayOptions, getPortfolioPlTrendTooltipMessages } from '../utils/profitLossUtils';

const useSwapDisplayOptions = ({ serviceId, selectedSwapDisplay }) => {
  const swapDisplayOptions = useMemo(() => getPortfolioPlTrendSwapDisplayOptions({ serviceId }), [serviceId]);

  const selectedSwapOption = useMemo(
    () => swapDisplayOptions.find((option) => option.value === selectedSwapDisplay) ?? swapDisplayOptions[0],
    [selectedSwapDisplay, swapDisplayOptions],
  );

  const { totalPlTooltipMessage, realizedPlTooltipMessage, swapTooltipMessage } = useMemo(
    () => getPortfolioPlTrendTooltipMessages({ selectedSwapDisplay, serviceId }),
    [selectedSwapDisplay, serviceId],
  );

  const getSwapPl = (totalRealizedSwapPl, totalUnrealizedSwapPl) =>
    selectedSwapDisplay === SWAP_DISPLAY_REALIZED ? totalRealizedSwapPl : totalUnrealizedSwapPl;

  const getChartData = (chartDataRealized, chartDataUnrealized) =>
    selectedSwapDisplay === SWAP_DISPLAY_REALIZED ? chartDataRealized : chartDataUnrealized;

  return {
    swapDisplayOptions,
    selectedSwapOption,
    totalPlTooltipMessage,
    realizedPlTooltipMessage,
    swapTooltipMessage,
    getSwapPl,
    getChartData,
  };
};

export default useSwapDisplayOptions;
